import Layout from "@/views/layout/Layout.vue";
const module_data_analysis = [
  {
    path: "/data-analysis",
    component: Layout,
    children: [
      {
        path: "modelList",
        name: "modelList",
        component: () => import("@/views/data-analysis/ModelList"),
        meta: {
          title: "模型管理",
          needLogin: true
        }
      },
      {
        path: "createModel",
        name: "createModel",
        component: () => import("@/views/data-analysis/CreateModel"),
        meta: {
          title: "新建模型",
          needLogin: true,
          keepAlive: true
        }
      },
      {
        path: "configModel",
        name: "configModel",
        component: () => import("@/views/data-analysis/ConfigModel"),
        meta: {
          title: "模型配置",
          needLogin: true
        }
      },
      {
        path: "configModelMain",
        name: "configModelMain",
        component: () => import("@/views/data-analysis/ConfigModelMain"),
        meta: {
          title: "主体配置页",
          needLogin: true
        }
      },
      {
        path: "ConfigModelIntervene",
        name: "ConfigModelIntervene",
        component: () => import("@/views/data-analysis/ConfigModelIntervene"),
        meta: {
          title: "干预配置",
          needLogin: true
        }
      },
      {
        path: "createModelItem",
        name: "createModelItem",
        component: () => import("@/views/data-analysis/CreateModelItem"),
        meta: {
          title: "新建风险模块",
          needLogin: true
        }
      },
      {
        path: "areaList",
        name: "areaList",
        component: () => import("@/views/data-analysis/AreaList"),
        meta: {
          title: "地区库管理",
          needLogin: true
        }
      },
      {
        path: "areaList_details",
        name: "areaList_details",
        component: () => import("@/views/data-analysis/AreaList_details"),
        meta: {
          title: "新建地区库管理",
          needLogin: true
        }
      },
      {
        path: "riskTypeList",
        name: "riskTypeList",
        component: () => import("@/views/data-analysis/RiskTypeList"),
        meta: {
          title: "风险分类管理",
          needLogin: true
        }
      },
      {
        path: "areaConfigList",
        name: "areaConfigList",
        component: () => import("@/views/data-analysis/AreaConfigList"),
        meta: {
          title: "国家配置列表",
          needLogin: true
        }
      },
      {
        path: "configAreaRisk",
        name: "configAreaRisk",
        component: () => import("@/views/data-analysis/ConfigAreaRisk"),
        meta: {
          title: "国家配置详情",
          needLogin: true
        }
      }
    ]
  }
];
export default module_data_analysis;
